module.exports = __webpack_public_path__ + "img/scene2-15.c58889ec.jpg";